import { IAudioUiStore } from "@/store/audio/ui/audio-ui.types";
import { ActiveRecordingConflictModalStore } from "@/store/audio/ui/modals/active-recording-conflict-modal.store";
import { SystemAudioRecordingFailedModalStore } from "@/store/audio/ui/modals/system-audio-recording-failed-modal.store";
import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { action, makeObservable, observable } from "mobx";
import type { Uuid } from "@/domains/global/identifiers";

export class AppStoreAudioUiStore extends AppSubStore implements IAudioUiStore {
  showOnboardingTooltip = false;
  autoStopModalVisible = false;
  modals: {
    activeRecordingConflict: ActiveRecordingConflictModalStore;
    systemAudioRecordingFailed: SystemAudioRecordingFailedModalStore;
  };

  constructor(injectedDeps: AppSubStoreArgs) {
    super(injectedDeps);

    this.modals = {
      activeRecordingConflict: new ActiveRecordingConflictModalStore(injectedDeps),
      systemAudioRecordingFailed: new SystemAudioRecordingFailedModalStore(injectedDeps),
    };

    makeObservable(this, {
      showOnboardingTooltip: observable,
      autoStopModalVisible: observable,
      setShowOnboardingTooltip: action,
      setAutoStopModalVisible: action,
      beginRecording: action,
      resetRecording: action,
      initialize: action,
      resetState: action,
      promptToReplaceActiveRecording: action,
      promptSystemAudioRecordingFailed: action,
      modals: observable,
    });
  }

  setShowOnboardingTooltip(value: boolean): void {
    this.showOnboardingTooltip = value;
  }

  setAutoStopModalVisible(value: boolean): void {
    this.autoStopModalVisible = value;
  }

  initialize(): void {
    this.resetRecording();
    this.showOnboardingTooltip = false;
    this.autoStopModalVisible = false;
  }

  beginRecording(): void {
    this.resetRecording();
  }

  resetRecording(): void {
    this.autoStopModalVisible = false;
  }

  resetState(): void {
    this.resetRecording();
  }

  promptToReplaceActiveRecording({
    onConfirm,
    onCancel,
  }: {
    onConfirm: () => Promise<void>;
    onCancel?: () => void;
  }): void {
    this.modals.activeRecordingConflict.open({
      onConfirm,
      onCancel,
    });
  }

  promptSystemAudioRecordingFailed({
    audioRecordingId,
    noteId,
    onConfirm,
    onRetry,
    onCancel,
  }: {
    audioRecordingId: Uuid;
    noteId: Uuid | null;
    onConfirm: () => Promise<void>;
    onRetry: () => Promise<void>;
    onCancel?: () => void;
  }): void {
    this.modals.systemAudioRecordingFailed.open({
      audioRecordingId,
      noteId,
      onConfirm,
      onRetry,
      onCancel,
    });
  }
}
